import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Button, Stack, TextField } from '@mui/material';

type CommandPaletteQueryProps = {
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClose?: () => void;
};

function CommandPaletteQuery({
  placeholder,
  value,
  onChange,
  onKeyDown,
  onClose,
}: CommandPaletteQueryProps) {
  return (
    <Stack p={3} borderBottom={1} borderColor={(theme) => theme.palette.grey[300]}>
      <TextField
        autoFocus
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        size="medium"
        variant="standard"
        sx={{
          paddingLeft: 2,
          paddingRight: 2,
        }}
        slotProps={{
          inputLabel: {
            style: { fontWeight: '600', fontSize: '1.125rem' }, // For the label
          },
          input: {
            startAdornment: (
              <Stack
                color={(theme) => theme.palette.grey[500]}
                width={'2em'}
                height={'2em'}
                display={'inline-flex'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <MagnifyingGlassIcon style={{ marginRight: 8, maxHeight: '2em' }} />
              </Stack>
            ),
            endAdornment: onClose ? (
              <Button
                onClick={onClose}
                variant="soft"
                color="secondary"
                size="small"
                sx={{ paddingLeft: 1, paddingRight: 1, minWidth: 'auto' }}
              >
                Esc
              </Button>
            ) : undefined,
            disableUnderline: true,
            style: { fontWeight: '600', fontSize: '1.125rem' },
            inputProps: {
              style: { fontWeight: '600', fontSize: '1.125rem' },
            },
          },
        }}
        fullWidth
        placeholder={placeholder}
      />
    </Stack>
  );
}

export default CommandPaletteQuery;
